import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';
const ApplicationJson = 'application/json';

class WebSocketAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = 'System';
  controllerName = 'Websockets';

  getConfigAsync() {
    const request = {url: [this.getAPIUrl(), 'config'].join('/')};
    return httpClient.getAsync(request, false, true, ApplicationJson, false);
  }
}

export default new WebSocketAPI();
